import VoicesSwiper from "./swiper.es6";
import MvMotion from "./mv-motion.es6";
import ContentsScrollTrigger from "./scroll-trigger.es6";
import AnchorLink from "./anchor-link.es6";
import Parallax from "./parallax.es6";
import MvBg from "./mv-Bg.es6";
import VoicesColor from "./voices-color.es6";
import ThemeModal from "./theme-modal.es6";

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        const voicesSwipe = new VoicesSwiper();
        const mvMotion = new MvMotion();
        const contentsScrollTrigger = new ContentsScrollTrigger();
        const anchorLink = new AnchorLink();
        const parallax = new Parallax();
        const mvBg = new MvBg();
        const voicesColor = new VoicesColor();
        const themeModal = new ThemeModal();
    }
}
